var map = {
	"./CS-615.png": [
		831,
		[
			831
		]
	],
	"./digital-pathology.png": [
		888,
		[
			888
		]
	],
	"./heavy-metal.png": [
		327,
		[
			327
		]
	],
	"./software-patterns.png": [
		509,
		[
			509
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 985;
module.exports = webpackAsyncContext;